module.exports = __webpack_public_path__ + "media/npc_dota_hero_broodmother.f0dcd99c.webm";